export enum ActivityType {
  comments = 'comments',
  log = 'log',
}
